module.exports = __webpack_public_path__ + "static/media/21.3672028d.jpg";